// Supplier Registration Request form (travel advisors only); used by My Dashboard and the account hub.
export const SUPPLIER_REGISTRATION_JOTFORM_SRC = 'https://form.jotform.com/262007387311047';
